import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import api from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Eye } from "lucide-react";

// Bandeau « Mode démo » + CTA commercial déclenché par le garde-fou serveur (403 demo_cta) lors d'une action réelle.
export function DemoBanner() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const h = () => setOpen(true);
    window.addEventListener("respondia:demo-cta", h);
    return () => window.removeEventListener("respondia:demo-cta", h);
  }, []);
  if (!user?.demo) return null;
  const go = async (mode) => { try { await api.post("/auth/logout"); } catch (e) {} window.location.assign(`/choisir?mode=${mode}`); };
  return (
    <>
      <div className="bg-amber-50 border-b border-amber-200 text-amber-900 text-xs sm:text-sm px-4 py-2 flex flex-wrap items-center gap-2 justify-between" data-testid="demo-banner">
        <span className="inline-flex items-center gap-1.5"><Eye className="w-4 h-4" /> <b>Mode démo — données d'exemple.</b> Aucune vraie mesure n'est lancée.</span>
        <div className="flex gap-2">
          <Button size="sm" onClick={() => go("trial")} className="h-7 rounded-lg bg-blue-600 hover:bg-blue-700 text-xs" data-testid="demo-banner-trial">Essayer gratuitement 7 jours</Button>
          <Button size="sm" variant="outline" onClick={() => go("direct")} className="h-7 rounded-lg text-xs" data-testid="demo-banner-subscribe">S'abonner maintenant</Button>
        </div>
      </div>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent data-testid="demo-cta-dialog">
          <DialogHeader><DialogTitle className="font-heading">Prêt à utiliser Respondia avec votre entreprise ?</DialogTitle></DialogHeader>
          <p className="text-sm text-slate-600">La démo utilise des données d'exemple : les actions réelles (analyses, mesures, publications, imports) sont réservées aux comptes clients.</p>
          <div className="flex flex-col sm:flex-row gap-2 mt-2">
            <Button onClick={() => go("trial")} className="rounded-xl bg-blue-600 hover:bg-blue-700" data-testid="demo-cta-trial">Essayer gratuitement 7 jours</Button>
            <Button variant="outline" onClick={() => go("direct")} className="rounded-xl" data-testid="demo-cta-subscribe">S'abonner maintenant</Button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
